import {
  createEntireLoadLookupSource,
  EMPTY_LOOKUP_SOURCE,
  LookupOption,
  LookupSource,
} from '@/components';
import {
  RtkqSpin,
  TaskGroupState,
  useLazyGetTaskGroupsListQuery,
} from '@/redux';
import { useMemo } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

function map(value: TaskGroupState): LookupOption {
  return {
    _search: value.name,
    value: value.id,
    label: value.name,
  };
}

function onNewValue(search: string): LookupOption {
  return {
    _search: search,
    value: search,
    label: <Text type="secondary">Create: "{search}"</Text>,
  };
}

export function useTaskGroupsLookupSource(projectId?: string): LookupSource {
  const [fetchList] = useLazyGetTaskGroupsListQuery();

  return useMemo(() => {
    if (!projectId) {
      return EMPTY_LOOKUP_SOURCE;
    }
    const entireSource = createEntireLoadLookupSource({
      initial: (id: string) =>
        fetchList(
          {
            projectId: projectId,
            [RtkqSpin]: false,
          },
          true,
        )
          .unwrap()
          .then((values) => map(values.find((x) => x.id === id)!)),
      load: () =>
        fetchList(
          {
            projectId: projectId,
            [RtkqSpin]: false,
          },
          true,
        )
          .unwrap()
          .then((values) => values.map(map)),
    });

    return {
      ...entireSource,
      onNewValue,
      searchField: '_search',
    };
  }, [fetchList, projectId]);
}
